<template>
  <v-form
    v-model="$storeBourse.validation.revenu"
    ref="refRevenus"
    lazy-validation
  >
    <v-layout row wrap xs12>
      <v-dialog v-model="dialog" max-width="70%">
        <v-form ref="form" v-model="valid">
          <v-card>
            <v-toolbar color="ecSecondary" dark>
              <v-toolbar-title>{{
                $storeUm6p.Label.Revenus.RenseignerRevenus +
                $storeUm6p.Label.AutresRevenus.AutresRevenusTitle +
                $storeBourse.DonneesFormulaireEC.anneeScolaireAutresRevenus?.lang00
              }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-alert
                  border="left"
                  colored-border
                  color="ecSecondary"
                  elevation="1"
                >
                  {{ $storeUm6p.Label.Revenus.RenseignerTousLesChamps }}
                </v-alert>
                <v-row>
                  <v-col cols="6">
                    <label>{{
                      $storeCatalogue.AffichageCatalogue(
                        $storeCatalogue.Parente,
                        $storeBourse.editedItem.parente,
                        $storeCommun.ItemLang
                      )
                    }}</label>
                  </v-col>
                  <v-col cols="6"> </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.RevenuMensuelNetDeclare }}
                    </label>
                    <br />
                    <small>
                      {{ $storeUm6p.Label.Revenus.HorsPension }}
                    </small>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="$storeBourse.editedItem.revenuNetMensuelDeclare"
                      v-bind:label="label"
                      v-bind:readonly="
                        $storeBourse.DonneesFormulaireEC.readOnly
                      "
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="$storeReglesBourse.obligatoire"
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showRevenuNetImposableAnnuelSalaire">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.RevenuNetAnnuelAttestation }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="
                        $storeBourse.editedItem.revenuNetAnnuelAttestation
                      "
                      v-bind:label="label"
                      v-bind:readonly="
                        $storeBourse.DonneesFormulaireEC.readOnly
                      "
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showRevenuNetImposableAnnuelSalaire
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showRevenuNetMensuelSalaire">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.RevenuNetMensuelAttestation }}
                    </label>
                    <br />
                    <small>
                      {{
                        $storeUm6p.Label.Revenus
                          .PhraseExplicativeRevenuNetMensuelAttestation
                      }}
                    </small>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="$storeBourse.editedItem.rnmAttestationSalaire"
                      v-bind:label="label"
                      v-bind:readonly="
                        $storeBourse.DonneesFormulaireEC.readOnly
                      "
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showRevenuNetMensuelSalaire
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showRevenuNetMensuelBulletinPaieRecent">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{
                        $storeUm6p.Label.Revenus.RevenuNetMensuelBulletinRecent
                      }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="$storeBourse.editedItem.rnmDernierBp"
                      v-bind:label="label"
                      v-bind:readonly="
                        $storeBourse.DonneesFormulaireEC.readOnly
                      "
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showRevenuNetMensuelBulletinPaieRecent
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showRevenuNetMensuelBulletinPaieDecembre">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{
                        $storeUm6p.Label.Revenus
                          .RevenuNetMensuelBulletinDecembre
                      }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="$storeBourse.editedItem.rnmBulletinPaieDec"
                      v-bind:label="label"
                      v-bind:readonly="
                        $storeBourse.DonneesFormulaireEC.readOnly
                      "
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showRevenuNetMensuelBulletinPaieDecembre
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showSommeRevenusNetMensuelToutesPensions">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.SommeMensuelPensions }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="$storeBourse.editedItem.sommeRnmPensionsPercues"
                      v-bind:label="label"
                      v-bind:readonly="
                        $storeBourse.DonneesFormulaireEC.readOnly
                      "
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showSommeRevenusNetMensuelToutesPensions
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showAllocationsFamiliales">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.AllocationPere }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="$storeBourse.editedItem.allocationsFamiliales"
                      v-bind:label="label"
                      v-bind:readonly="
                        $storeBourse.DonneesFormulaireEC.readOnly
                      "
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showAllocationsFamiliales
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showSommeRevenusNetMensuelPensions">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.PensionMere }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="
                        $storeBourse.editedItem.sommeRnmPensionsPercuesMere
                      "
                      v-bind:label="label"
                      v-bind:readonly="
                        $storeBourse.DonneesFormulaireEC.readOnly
                      "
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showSommeRevenusNetMensuelPensions
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.RevenuNetAnnuelDgi }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="$storeBourse.editedItem.rniAnnuelAttestationDGI"
                      v-bind:label="label"
                      v-bind:readonly="
                        $storeBourse.DonneesFormulaireEC.readOnly
                      "
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="$storeReglesBourse.obligatoire"
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showAutreRevenuNetAnnuel">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.AutreRevenuNetAnnuel }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="$storeBourse.editedItem.rnmAutre"
                      v-bind:label="label"
                      v-bind:readonly="
                        $storeBourse.DonneesFormulaireEC.readOnly
                      "
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showAutreRevenuNetAnnuel
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <small>
                      {{ $storeUm6p.Label.Revenus.Note1 }}
                    </small>
                    <br />
                    <small>
                      {{ $storeUm6p.Label.Revenus.Note2 }}
                    </small>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12">
                    <v-alert
                      border="left"
                      colored-border
                      color="ecSecondary"
                      elevation="1"
                    >
                      {{ $storeUm6p.Label.Revenus.RevenuAnnuelGlobal }}
                    </v-alert>
                    <v-simple-table>
                      <thead>
                        <tr class="text-sm-left">
                          <th>
                            {{ $storeUm6p.Label.Revenus.NatureDesRevenus }}
                          </th>
                          <th>
                            {{ $storeUm6p.Label.Revenus.CAHT }}
                          </th>
                          <th>
                            {{ $storeUm6p.Label.Revenus.MontantRevenuNetImp }}
                          </th>
                          <th>
                            {{ $storeUm6p.Label.Revenus.Employeur }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="asterisk">
                            {{ $storeUm6p.Label.Revenus.RevenusProfessionnels }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.professionnelsCaHt
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem
                                  .professionnelsNetImposable
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="
                                $storeBourse.editedItem.professionnelsEmployeur
                              "
                              :readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="asterisk">
                            {{ $storeUm6p.Label.Revenus.RevenusAgricoles }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="$storeBourse.editedItem.agricolesCaHt"
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.agricolesNetImposable
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="
                                $storeBourse.editedItem.agricolesEmployeur
                              "
                              :readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="asterisk">
                            {{ $storeUm6p.Label.Revenus.RevenusSalariaux }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.salariauxEtAssimilesCaHt
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem
                                  .salariauxEtAssimilesNetImposable
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="
                                $storeBourse.editedItem
                                  .salariauxEtAssimilesEmployeur
                              "
                              :readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="asterisk">
                            {{ $storeUm6p.Label.Revenus.RevenusFonciers }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="$storeBourse.editedItem.fonciersCaHt"
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.fonciersNetImposable
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="
                                $storeBourse.editedItem.fonciersEmployeur
                              "
                              :readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="asterisk">
                            {{ $storeUm6p.Label.Revenus.RevenusCapitauxImmo }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.capitauxMobiliersCaHt
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem
                                  .capitauxMobiliersNetImposable
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="
                                $storeBourse.editedItem
                                  .capitauxMobiliersEmployeur
                              "
                              :readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="asterisk">
                            {{
                              $storeUm6p.Label.Revenus.RevenusSourcesEtrangeres
                            }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.profitsEtrangersCaHt
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem
                                  .profitsEtrangersNetImposable
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="
                                $storeBourse.editedItem
                                  .profitsEtrangersEmployeur
                              "
                              :readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12">
                        <v-alert
                          border="left"
                          colored-border
                          color="ecSecondary"
                          elevation="1"
                        >
                          {{
                            $storeUm6p.Label.AutresRevenus
                              .AutresRevenusAnnuelsDirham +
                            $storeUm6p.Label.AutresRevenus.AutresRevenusTitle +
                            $storeBourse.DonneesFormulaireEC.anneeScolaireAutresRevenus?.lang00
                          }}
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-simple-table
                      v-if="$storeBourse.editedItem.autreRevenuDto"
                    >
                      <tbody>
                        <tr>
                          <td>
                            <label class="asterisk">
                              {{
                                $storeUm6p.Label.AutresRevenus
                                  .RevenusAgricolesAnnuels
                              }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.autreRevenuDto
                                  .revenuAgricole
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td>
                            <label class="asterisk">
                              {{
                                $storeUm6p.Label.AutresRevenus.RevenusLocatifNef
                              }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.autreRevenuDto
                                  .revenuLocatifNet
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label class="asterisk">
                              {{ $storeUm6p.Label.AutresRevenus.Dividendes }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.autreRevenuDto
                                  .dividendes
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <label class="asterisk">
                              {{
                                $storeUm6p.Label.AutresRevenus
                                  .AutreRevenusNetAnnuels
                              }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.autreRevenuDto
                                  .autresRevenus
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td>
                            <label
                              :class="
                                $storeBourse.editedItem.autreRevenuDto
                                  .autresRevenus &&
                                $storeBourse.editedItem.autreRevenuDto
                                  .autresRevenus > 0
                                  ? 'asterisk'
                                  : ''
                              "
                            >
                              {{
                                $storeUm6p.Label.AutresRevenus.PrecisezLaNature
                              }}
                            </label>
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="
                                $storeBourse.editedItem.autreRevenuDto
                                  .natureRevenus
                              "
                              :readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              :rules="
                                $storeBourse.editedItem.autreRevenuDto
                                  .autresRevenus &&
                                $storeBourse.editedItem.autreRevenuDto
                                  .autresRevenus > 0
                                  ? $storeReglesBourse.obligatoire
                                  : []
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                    <v-row>
                      <v-col cols="12">
                        <v-alert
                          border="left"
                          colored-border
                          color="ecSecondary"
                          elevation="1"
                        >
                          {{
                            $storeUm6p.Label.AutresRevenus.RevenuExceptionnels +
                            $storeUm6p.Label.AutresRevenus.AutresRevenusTitle +
                            $storeBourse.DonneesFormulaireEC.anneeScolaireAutresRevenus?.lang00
                          }}
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-simple-table
                      v-if="$storeBourse.editedItem.autreRevenuDto"
                    >
                      <tbody>
                        <tr>
                          <td>
                            <label class="asterisk">
                              {{
                                $storeUm6p.Label.AutresRevenus.ProduitVenteImmo
                              }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.autreRevenuDto
                                  .produitVenteBien
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td>
                            <label class="asterisk">
                              {{ $storeUm6p.Label.AutresRevenus.Heritages }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.autreRevenuDto.heritage
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label class="asterisk">
                              {{
                                $storeUm6p.Label.AutresRevenus
                                  .AutresRevenusExceptionnels
                              }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                $storeBourse.editedItem.autreRevenuDto
                                  .autresRevenusExceptionnels
                              "
                              v-bind:label="label"
                              v-bind:readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td>
                            <label
                              :class="
                                $storeBourse.editedItem.autreRevenuDto
                                  .autresRevenusExceptionnels &&
                                $storeBourse.editedItem.autreRevenuDto
                                  .autresRevenusExceptionnels > 0
                                  ? 'asterisk'
                                  : ''
                              "
                            >
                              {{
                                $storeUm6p.Label.AutresRevenus.PrecisezLaNature
                              }}
                            </label>
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="
                                $storeBourse.editedItem.autreRevenuDto
                                  .natureRevenusExceptionnels
                              "
                              :readonly="
                                $storeBourse.DonneesFormulaireEC.readOnly
                              "
                              :rules="
                                $storeBourse.editedItem.autreRevenuDto
                                  .autresRevenusExceptionnels &&
                                $storeBourse.editedItem.autreRevenuDto
                                  .autresRevenusExceptionnels > 0
                                  ? $storeReglesBourse.obligatoire
                                  : []
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <!-- Tableau des crédits/financement -->
                <v-col cols="12">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.SituationASaisir"
                    v-model="$storeBourse.editedItem.situationASaisir"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    clearable
                    :rules="$storeReglesBourse.obligatoire"
                    class="asterisk"
                    @change="
                      changeSituation($storeBourse.editedItem.situationASaisir);
                      addCredit(false)
                    "
                  />
                </v-col>
                <v-simple-table
                  v-show="
                    $storeBourse.editedItem.situationASaisir ==
                    $storeCatalogue.DataId.Oui
                  "
                >
                  <thead>
                    <tr>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.TypeFinancement }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.MontantGlobal }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.Duree }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.MontantEcheance }}
                      </th>
                      <th>
                        <v-btn
                          color="ecPrimary"
                          small
                          class="mr-2"
                          @click="addCredit(true)"
                          v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
                        >
                          {{ $storeUm6p.Label.Ajouter }}
                        </v-btn>
                      </th>
                    </tr>
                  </thead>
                  <tbody v-for="(credit, index) in editedCredits" :key="credit.IdCrypte">
                    <tr v-show="!credit.Supprimer">
                      <td class="pt-6">
                        <v-autocomplete
                          :label="
                            $storeUm6p.Label.AutresRevenus.TypeFinancement
                          "
                          v-model="credit.typeFinancement"
                          :item-text="$storeCommun.ItemLang"
                          item-value="id"
                          :items="$storeCatalogue.TypeFinancement"
                          clearable
                          outlined
                          :rules="
                            uneSituationASaisir
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                          dense
                          background-color="white"
                        />
                      </td>
                      <td class="pt-6">
                        <VuetifyMoney
                          dense
                          v-model="credit.montantGlobal"
                          v-bind:label="label"
                          v-bind:readonly="
                            $storeBourse.DonneesFormulaireEC.readOnly
                          "
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:options="options"
                          :rules="
                            uneSituationASaisir
                              ? [
                                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                                    credit.montantGlobal
                                  ),
                                ]
                              : []
                          "
                        />
                      </td>
                      <td class="pt-6">
                        <v-text-field
                          background-color="white"
                          v-model="credit.duree"
                          outlined
                          dense
                          :rules="
                            uneSituationASaisir
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                        />
                      </td>
                      <td class="pt-6">
                        <VuetifyMoney
                          dense
                          v-model="credit.montantEcheance"
                          v-bind:label="label"
                          v-bind:readonly="
                            $storeBourse.DonneesFormulaireEC.readOnly
                          "
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:options="options"
                          :rules="
                            uneSituationASaisir
                              ? [
                                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                                    credit.montantEcheance
                                  ),
                                ]
                              : []
                          "
                        />
                      </td>
                      <td class="pt-6">
                        <v-icon
                          small
                          class="mr-2"
                          v-show="!$storeBourse.DonneesFormulaireEC.readOnly
                          && index > 0"
                          @click="deleteCredit(credit)"
                        >
                          {{ icons.mdiDelete }}
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <!-- FIN Tableau des crédits/financement -->
                <!-- Tableau des biens immobiliers -->
                <v-col cols="12">
                  <v-autocomplete
                    :label="
                      $storeUm6p.Label.Parents.BienImmoSecondaireParentsTuteurs
                    "
                    v-model="
                      $storeBourse.editedItem.bienImmoSecondaireParentsTuteurs
                    "
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    clearable
                    :rules="$storeReglesBourse.obligatoire"
                    class="asterisk"
                    @change="
                      DisplayPopup(
                        $storeBourse.editedItem.bienImmoSecondaireParentsTuteurs
                      );
                      addBienImmo(false)
                    "
                  />
                </v-col>
                <v-dialog v-model="dialogImmo.informations.model" width="500">
                  <v-card>
                    <v-card-title>{{
                      $storeUm6p.Label.Informations
                    }}</v-card-title>
                    <v-card-text>
                      <p
                        v-html="$storeUm6p.Label.AutresRevenus.PopupNBBienImmoECC"
                      ></p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="ecPrimary"
                        text
                        @click="dialogImmo.informations.model = false"
                      >
                        Fermer
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogRevenuAlert.model" width="500">
                  <v-card>
                    <v-card-title>{{ $storeUm6p.Label.Informations }}</v-card-title>
                    <v-card-text>
                      <p>{{ dialogRevenuAlert.message }}</p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialogRevenuAlert.model = false">
                        Fermer
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <div
                  v-show="
                    $storeBourse.editedItem.bienImmoSecondaireParentsTuteurs ==
                    $storeCatalogue.DataId.Oui
                  "
                >
                  <v-btn
                    color="ecPrimary"
                    small
                    class="mr-2"
                    @click="addBienImmo(true)"
                    v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
                  >
                    {{ $storeUm6p.Label.Ajouter }}
                  </v-btn>
                </div>
                <v-simple-table
                  class="table table_revenus"
                  v-show="
                    $storeBourse.editedItem.bienImmoSecondaireParentsTuteurs ==
                    $storeCatalogue.DataId.Oui
                  "
                >
                  <thead>
                    <tr>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.NombreBiens }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.NatureBien }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.SuperficieBien }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.AdresseBien }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.NumeroTitreFoncier }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.DateAcquisitionBien }}
                      </th>
                      <th class="asterisk">
                        {{
                          $storeUm6p.Label.AutresRevenus.ValeurAcquisitionBien
                        }}
                      </th>
                      <th class="asterisk">
                        {{
                          $storeUm6p.Label.AutresRevenus.ValeurEstimativeBien
                        }}
                      </th>
                      <th class="asterisk">
                        {{
                          $storeUm6p.Label.AutresRevenus.SourceEstimationBien
                        }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(bien, index) in editedBiensImmo"
                    :key="bien.Id"
                  >
                    <tr v-show="!bien.Supprimer">
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.nombreBiens"
                          :ref="'nombreBien' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.EstNumeriqueObligatoire
                              : []
                          "
                          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                          outlined
                          dense
                        />
                      </td>
                      <td>
                        <v-autocomplete
                          background-color="white"
                          label="Nature du bien"
                          v-model="bien.natureBien"
                          :ref="'natureBien' + index"
                          :item-text="$storeCommun.ItemLang"
                          item-value="id"
                          :items="$storeCatalogue.NatureBien"
                          clearable
                          outlined
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                          dense
                          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.superficie"
                          :ref="'superficie' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.EstNumeriqueObligatoire
                              : []
                          "
                          outlined
                          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                          dense
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.adresse"
                          :ref="'adresse' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                          outlined
                          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                          dense
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.numeroTitreFoncier"
                          :ref="'numeroTitreFoncier' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                          outlined
                          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                          dense
                        />
                      </td>
                      <td>
                        <input
                          class="dateAcquisitionClass"
                          :ref="'dateAcquisition' + index"
                          type="date"
                          v-model="bien.dateAcquisition"
                          required
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.valeurAcquisition"
                          :ref="'valeurAcquisition' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? [
                                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                                    bien.valeurAcquisition
                                  ),
                                ]
                              : []
                          "
                          outlined
                          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                          dense
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.valeurEstimative"
                          :ref="'valeurEstimative' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? [
                                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                                    bien.valeurEstimative
                                  ),
                                ]
                              : []
                          "
                          outlined
                          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                          dense
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.sourceEstimation"
                          :ref="'sourceEstimation' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                          outlined
                          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
                          dense
                        />
                      </td>
                      <td>
                        <v-icon
                          small
                          class="mr-2"
                          v-show="
                          !$storeBourse.DonneesFormulaireEC.readOnly
                          && index > 0"
                          @click="deleteBiens(bien)"
                        >
                          {{ icons.mdiDelete }}
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <!-- FIN Tableau des biens immobiliers -->
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small dark color="ecSecondary" @click="close">{{
                $storeUm6p.Label.Annuler
              }}</v-btn>
              <v-btn small dark color="ecSecondary" @click="save">{{
                $storeUm6p.Label.Valider
              }}</v-btn>
            </v-card-actions>
            <v-dialog v-model="afficherListeErreurs.informations.model" width="500">
              <v-card>
                <v-card-title>{{ $storeUm6p.Label.Informations }}</v-card-title>
                <v-card-text>
                  <p v-html="$storeUm6p.Label.Revenus.InfoRenseignementChampsObligatoire"></p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="ecPrimary"
                    text
                    @click="afficherListeErreurs.informations.model = false"
                  >
                    Fermer
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card>
        </v-form>
      </v-dialog>
      <!-- fin dialog -->
    </v-layout>
    <v-alert
      border="left"
      colored-border
      color="ecSecondary"
      elevation="1"
      v-show="$storeBourse.DonneesFormulaireEC.lienDocumentSalaire"
    >
      {{ $storeUm6p.Label.Revenus.ModeleAttestationSalarie }}
      <v-icon
        class="mr-2"
        :title="$storeUm6p.Label.AfficherDocument"
        @click="
          $storeCommun.AfficherAnnexe(
            $storeBourse.DonneesFormulaireEC.lienDocumentSalaire
          )
        "
      >
        {{ icons.mdiFileDownload }}
      </v-icon>
    </v-alert>
    <v-alert
      border="left"
      colored-border
      color="ecSecondary"
      elevation="1"
      v-show="$storeBourse.DonneesFormulaireEC.lienDocumentDgi"
    >
      {{ $storeUm6p.Label.Revenus.ModeleAttestationDgi }}
      <v-icon
        class="mr-2"
        :title="$storeUm6p.Label.AfficherDocument"
        @click="
          $storeCommun.AfficherAnnexe(
            $storeBourse.DonneesFormulaireEC.lienDocumentDgi
          )
        "
      >
        {{ icons.mdiFileDownload }}
      </v-icon>
    </v-alert>
    <h5>
      {{ $storeUm6p.Label.Revenus.RevenusCompleterTuteurs }}
    </h5>
    <!-- Début Liste -->
    <v-data-table
      :headers="$storeUm6p.Label.Revenus.Headers"
      :items="$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr v-if="!item.supprimer && item.tuteur == $storeCatalogue.DataId.Oui">
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.Parente,
                item.parente,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th>
            <v-btn small @click="editItem(item)">
              <v-icon small class="ma-2">{{ icons.mdiPencil }}</v-icon>
              {{ $storeUm6p.Label.Revenus.RenseignerRevenus }}</v-btn
            >
          </th>
        </tr>
      </template>
    </v-data-table>
    <br />
    <v-row>
      <v-col cols="12">
        <h5>
          {{ $storeUm6p.Label.Parents.FraisUnivEmployeur }}
        </h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          label=""
          v-model="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .fraisUniversitaire
          "
          ref="fraisuniv"
          :rules="$storeReglesBourse.obligatoire"
          :itemprop="$storeUm6p.Label.Parents.ChargeFraisUniv"
          :item-text="$storeCommun.ItemLang"
          item-value="id"
          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
          :items="$storeCatalogue.OuiNon"
        />
      </v-col>
      <v-col cols="6">
        <VuetifyMoney
          v-model="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .montantFraisUniversitaire
          "
          :label="$storeUm6p.Label.Parents.MontantBourse"
          v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
          v-bind:disabled="disabled"
          v-bind:outlined="outlined"
          v-bind:clearable="clearable"
          v-bind:options="options"
          :rules="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .fraisUniversitaire == $storeCatalogue.DataId.Oui
              ? [
                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                    $storeBourse.DonneesFormulaireEC.infosComplementaires
                      .montantFraisUniversitaire
                  ),
                ]
              : []
          "
          ref="montantbourse"
          v-show="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .fraisUniversitaire == $storeCatalogue.DataId.Oui
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h5>
          {{ $storeUm6p.Label.Parents.CompteEpargne }}
        </h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          label=""
          v-model="
            $storeBourse.DonneesFormulaireEC.infosComplementaires.compteEpargne
          "
          :item-text="$storeCommun.ItemLang"
          item-value="id"
          :items="$storeCatalogue.OuiNon"
          :rules="$storeReglesBourse.obligatoire"
          ref="compteepargne"
          :itemprop="$storeUm6p.Label.Parents.CompteEpargneItem"
          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
        />
      </v-col>
      <v-col cols="6">
        <VuetifyMoney
          v-model="
            $storeBourse.DonneesFormulaireEC.infosComplementaires.montantEpargne
          "
          :label="$storeUm6p.Label.Parents.MontantEpargne"
          v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
          v-bind:disabled="disabled"
          v-bind:outlined="outlined"
          v-bind:clearable="clearable"
          v-bind:options="options"
          :rules="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .compteEpargne == $storeCatalogue.DataId.Oui
              ? [
                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                    $storeBourse.DonneesFormulaireEC.infosComplementaires
                      .montantEpargne
                  ),
                ]
              : []
          "
          ref="montantcomptesepargnes"
          v-show="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .compteEpargne == $storeCatalogue.DataId.Oui
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h5>
          {{ $storeUm6p.Label.Parents.ValeurImmobiliere }}
        </h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          label=""
          v-model="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .valeurImmobiliere
          "
          ref="valeursimmo"
          :rules="$storeReglesBourse.obligatoire"
          :itemprop="$storeUm6p.Label.Parents.ValeurImmobiliereItem"
          :item-text="$storeCommun.ItemLang"
          item-value="id"
          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
          :items="$storeCatalogue.OuiNon"
        />
      </v-col>
      <v-col cols="6">
        <VuetifyMoney
          v-model="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .valeurTotaleTitres
          "
          :label="$storeUm6p.Label.Parents.ValeurTotaleTitres"
          v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
          v-bind:disabled="disabled"
          v-bind:outlined="outlined"
          v-bind:clearable="clearable"
          v-bind:options="options"
          v-bind:rules="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .valeurImmobiliere == $storeCatalogue.DataId.Oui
              ? [
                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                    $storeBourse.DonneesFormulaireEC.infosComplementaires
                      .valeurTotaleTitres
                  ),
                ]
              : []
          "
          ref="montantvaleurmobiliere"
          v-show="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .valeurImmobiliere == $storeCatalogue.DataId.Oui
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h5>
          {{ $storeUm6p.Label.Parents.DepotsTermes }}
        </h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          label=""
          v-model="
            $storeBourse.DonneesFormulaireEC.infosComplementaires.depotsTermes
          "
          ref="depotstermes"
          :rules="$storeReglesBourse.obligatoire"
          itemprop="Dépôts à termes"
          :item-text="$storeCommun.ItemLang"
          item-value="id"
          :readonly="$storeBourse.DonneesFormulaireEC.readOnly"
          :items="$storeCatalogue.OuiNon"
        />
      </v-col>
      <v-col cols="6">
        <VuetifyMoney
          v-model="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .montantDuCapital
          "
          :label="$storeUm6p.Label.Parents.MontantDuCapital"
          itemprop="Dépôts à termes"
          v-bind:readonly="$storeBourse.DonneesFormulaireEC.readOnly"
          v-bind:disabled="disabled"
          v-bind:outlined="outlined"
          v-bind:clearable="clearable"
          v-bind:options="options"
          v-bind:rules="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .depotsTermes == $storeCatalogue.DataId.Oui
              ? [
                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                    $storeBourse.DonneesFormulaireEC.infosComplementaires
                      .montantDuCapital
                  ),
                ]
              : []
          "
          ref="montantDuCapital"
          v-show="
            $storeBourse.DonneesFormulaireEC.infosComplementaires
              .depotsTermes == $storeCatalogue.DataId.Oui
          "
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import VuetifyMoney from "../VuetifyMoney";
import { mdiPencil, mdiFileDownload, mdiPlusThick, mdiDelete } from "@mdi/js";
export default {
  components: {
    VuetifyMoney,
  },
  data() {
    return {
      // Param des rubriques revenus
      afficherListeErreurs: {
        informations: {
          model: false,
          texte: null,
        }
      },
      label: "",
      disabled: false,
      outlined: true,
      clearable: false,
      options: {
        locale: "fr-FR",
        prefix: "DH",
        suffix: "",
        length: 9,
        precision: 2,
      },

      // booleen pour affichage des blocs
      showRevenuNetImposableAnnuelSalaire: false,
      showRevenuNetMensuelSalaire: false,
      showRevenuNetMensuelBulletinPaieRecent: false,
      showRevenuNetMensuelBulletinPaieDecembre: false,
      showAutreRevenuNetAnnuel: false,
      showSommeRevenusNetMensuelToutesPensions: false,
      showAllocationsFamiliales: false,
      showSommeRevenusNetMensuelPensions: false,

      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPencil,
        mdiFileDownload,
        mdiPlusThick,
        mdiDelete,
      },
      // Réaffecter l'objet global pour forcer la maj en temps réel
      $storeCatalogue: this.$storeCatalogue,
      $storeCommun: this.$storeCommun,
      $storeUm6p: this.$storeUm6p,
      $storeBourse: this.$storeBourse,
      // dialog pour ouvrir/fermer la popup
      dialog: false,
      dialogImmo: {
        informations: {
          model: false,
          texte: null,
        },
      },
      dialogRevenuAlert: {
        model: false,
        message: '',
      },

      // Validation du formulaire
      valid: false,

      // index de l'objet édité.
      editedIndex: -1,
      creditIndex: -1,
      bienIndex: -1,

      // Item local
      editedCredits: [],
      editedBiensImmo: [],
      blankItem: {
        autreRevenuDto: {},
        listeBiensImmo: [],
        listeCredits: [],
      },
    };
  },
  computed: {
    uneSituationASaisir() {
      return (
        this.$storeBourse.editedItem.situationASaisir ==
        this.$storeCatalogue.DataId.Oui
      );
    },
    estProprietairedeBiensImmo() {
      return (
        this.$storeBourse.DonneesFormulaireEC.infosComplementaires
          .proprietaireDeBiensImmobiliersSecondaire ==
        this.$storeCatalogue.DataId.Oui
      );
    },
    newBien(){
      return {
        Supprimer: false,
        CandidatureBourse: this.$storeBourse.editedItem.candidatureBourseId,
        CandidatureBourseFirsi:
          this.$storeBourse.editedItem.candidatureBourseFirsi,
        IdCrypte: null,
        SituationFamiliale: this.$storeBourse.editedItem.idCrypte,
        FinancementPropriete: this.$storeCatalogue.DataId.TypeRevenuPropriete,
        PersonneConcernee: this.$storeCatalogue.PersonneConcerne(
          this.$storeBourse.editedItem.parente
        ),
        Adresse: null,
        Duree: null,
        NombreBiens: null,
        MontantEcheance: null,
        MontantGlobal: null,
        Superficie: null,
        NatureBien: null,
        TypeFinancement: null,
        NumeroTitreFoncier: null,
        DateAcquisition: null,
        ValeurAcquisition: null,
        ValeurEstimative: null,
        SourceEstimation: null,
      }
    },
    newCredit(){
      return {
        Supprimer: false,
        CandidatureBourse: this.$storeBourse.editedItem.candidatureBourseId,
        CandidatureBourseFirsi:
          this.$storeBourse.editedItem.candidatureBourseFirsi,
        IdCrypte: null,
        SituationFamiliale: this.$storeBourse.editedItem.idCrypte,
        Adresse: null,
        Duree: null,
        NombreBiens: null,
        MontantEcheance: null,
        MontantGlobal: null,
        Superficie: null,
        FinancementPropriete: this.$storeCatalogue.DataId.TypeRevenuCredit,
        NatureBien: null,
        PersonneConcernee: this.$storeCatalogue.PersonneConcerne(
          this.$storeBourse.editedItem.parente
        ),
        TypeFinancement: null,
      }
    }
  },
  methods: {
    changeSituation(value) {
      if (value == this.$storeCatalogue.DataId.Non) {
        this.editedCredits.splice(0);
      }
    },
    DisplayPopup(value) {
      if (value == this.$storeCatalogue.DataId.Oui) {
        this.dialogImmo.informations.model = true;
      } else if (value == this.$storeCatalogue.DataId.Non) {
        this.editedBiensImmo.splice(0);
      }
    },
    ValiderForm() {
      this.$refs.refRevenus.validate();
      let listeErreur = [];

      // Vérifier les rubriques pour chaque parent
      this.$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale.forEach(
        (parent) => {
          let parente = this.$storeCatalogue.AffichageCatalogue(
            this.$storeCatalogue.Parente,
            parent.parente,
            this.$storeCommun.ItemLang
          );

          if (
            parent.tuteur == this.$storeCatalogue.DataId.Oui &&
            (parent.revenuNetMensuelDeclare == null ||
              parent.rniAnnuelAttestationDGI == null ||
              parent.professionnelsCaHt == null ||
              parent.professionnelsNetImposable == null ||
              parent.agricolesCaHt == null ||
              parent.agricolesNetImposable == null ||
              parent.salariauxEtAssimilesCaHt == null ||
              parent.salariauxEtAssimilesNetImposable == null ||
              parent.fonciersCaHt == null ||
              parent.fonciersNetImposable == null ||
              parent.capitauxMobiliersCaHt == null ||
              parent.capitauxMobiliersNetImposable == null ||
              parent.profitsEtrangersCaHt == null ||
              parent.profitsEtrangersNetImposable == null ||
              !parent.situationASaisir ||
              !parent.bienImmoSecondaireParentsTuteurs)
          ) {
            listeErreur.push(
              this.$storeUm6p.Label.Parents.CompleterRevenus + parente
            );
          }

          if (
            parent.tuteur == this.$storeCatalogue.DataId.Oui &&
            parent.situationASaisir === this.$storeCatalogue.DataId.Oui &&
            parent.listeCredits.length === 0
          ) {
            listeErreur.push(
              this.$storeUm6p.Label.Parents.AjouterCredits + parente
            );
          }

          if (
            parent.bienImmoSecondaireParentsTuteurs ===
              this.$storeCatalogue.DataId.Oui &&
            parent.listeBiensImmo.length === 0
          ) {
            listeErreur.push(
              this.$storeUm6p.Label.Parents.AjouterBiensImmo + parente
            );
          }
        }
      );

      let clesExclues = ["refRevenus", "form"];
      listeErreur.push(
        this.$storeBourse.ValiderForm(this.$refs.refRevenus, clesExclues)
      );
      return listeErreur;
    },
    formatNumber(number) {
      if (isNaN(number)) {
        number = "0";
      } else {
        // number = Number(number).toLocaleString(this.options.locale, {maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
        number = Number(number).toLocaleString("pt-BR", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });
      }
      return number.replace(",", "");
    },
    editItem(item) {
      // Récupère l'item à éditer et l'affecte à editItem local pour remplir les rubriques du formulaire popup.
      this.editedIndex =
        this.$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale.indexOf(
          item
        );
      this.$storeBourse.editedItem = Object.assign({}, item);

      this.editedCredits = JSON.parse(JSON.stringify(item.listeCredits));
      this.editedBiensImmo = JSON.parse(JSON.stringify(item.listeBiensImmo));

      // affichage des blocs
      this.showRevenuNetImposableAnnuelSalaire =
        this.$storeBourse.editedItem.secteurActivitePro ==
          this.$storeCatalogue.SecteurSalarie &&
        this.$storeBourse.editedItem.situationPro !=
          this.$storeCatalogue.SituationProRetraite;
      this.showRevenuNetMensuelSalaire =
        this.$storeBourse.editedItem.secteurActivitePro ==
          this.$storeCatalogue.SecteurSalarie &&
        this.$storeBourse.editedItem.situationPro !=
          this.$storeCatalogue.SituationProRetraite;
      this.showRevenuNetMensuelBulletinPaieRecent =
        this.$storeBourse.editedItem.situationPro !=
          this.$storeCatalogue.SituationProRetraite &&
        (this.$storeBourse.editedItem.secteurActivitePro ==
          this.$storeCatalogue.SecteurSalarie ||
          this.$storeBourse.editedItem.secteurActivitePro ==
            this.$storeCatalogue.SecteurFonctionnaire);
      this.showRevenuNetMensuelBulletinPaieDecembre =
        this.$storeBourse.editedItem.situationPro !=
          this.$storeCatalogue.SituationProRetraite &&
        (this.$storeBourse.editedItem.secteurActivitePro ==
          this.$storeCatalogue.SecteurSalarie ||
          this.$storeBourse.editedItem.secteurActivitePro ==
            this.$storeCatalogue.SecteurFonctionnaire);
      this.showAutreRevenuNetAnnuel =
        this.$storeBourse.editedItem.situationPro !=
        this.$storeCatalogue.SituationProNonActif;
      this.showSommeRevenusNetMensuelToutesPensions =
        this.$storeBourse.editedItem.situationPro ==
          this.$storeCatalogue.SituationProRetraite ||
          this.$storeBourse.editedItem.situationPro ==
          this.$storeCatalogue.DataId.SituationProRetraiteActif;
      this.showAllocationsFamiliales =
        this.$storeBourse.editedItem.parente ==
          this.$storeCatalogue.DataId.ParenteMere &&
        (this.$storeBourse.editedItem.statutParentTuteur ==
          this.$storeCatalogue.SituationFamDivorce ||
          this.$storeBourse.editedItem.statutParentTuteur ==
            this.$storeCatalogue.SituationFamDivorceRemarie);
      this.showSommeRevenusNetMensuelPensions =
        this.$storeBourse.editedItem.parente ===
          this.$storeCatalogue.DataId.ParenteMere &&
        this.$storeBourse.editedItem.statutParentTuteur
           === this.$storeCatalogue.SituationFamVeuf;

      // ouvre le popup
      this.dialog = true;
    },
    close() {
      // RAZ des champs du formulaire
      this.$refs.form.resetValidation();
      // ferme le popup
      this.dialog = false;
      // on remet à zéro le $storeBourse.editedItem local
      this.$storeBourse.editedItem = Object.assign({}, this.blankItem);

      this.editedIndex = -1;
      this.bienIndex = -1;
      this.creditIndex = -1;
    },
    save() {
      // Vérification des alertes de revenus
      this.checkRevenuAlerts();
      if (this.dialogRevenuAlert.model) {
        return;
      }
      // validation du formulaire
      if(!this.valid)
      {
        this.afficherListeErreurs.informations.model = true;
      }
      
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }

      // on passe le item local à false.
      this.$storeBourse.editedItem.supprimer = false;

      // On affecte les liste local à l'$storeBourse.editedItem local
      this.$storeBourse.editedItem.listeCredits = this.editedCredits;
      this.$storeBourse.editedItem.listeBiensImmo = this.editedBiensImmo;

      // on modifie l'item dans le store si l'editedIndex est renseigné.
      if (this.editedIndex > -1) {
        Object.assign(
          this.$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale[
            this.editedIndex
          ],
          this.$storeBourse.editedItem
        );
      }
      // sinon, on ajoute l'item local au store.
      else {
        this.$storeBourse.DonneesFormulaireEC.listeSituationsFamiliale.push(
          this.$storeBourse.editedItem
        );
      }

      // on appelle close pour raz l'item local + fermer le popup
      this.close();
    },
    addBienImmo(flag) {
      if(this.$storeBourse.editedItem.bienImmoSecondaireParentsTuteurs === this.$storeCatalogue.DataId.Oui){
        if(flag){
          this.editedBiensImmo.push(Object.assign({},this.newBien));
        }
        else if(this.editedBiensImmo.length === 0){
          this.editedBiensImmo.push(Object.assign({},this.newBien));
        }
      }
      else{
        this.editedBiensImmo.splice(0);
      }
    },
    addCredit(flag) {
      if(this.$storeBourse.editedItem.situationASaisir === this.$storeCatalogue.DataId.Oui){
        if(flag){
          this.editedCredits.push(Object.assign({},this.newCredit));
        }
        else if(this.editedCredits.length === 0){
          this.editedCredits.push(Object.assign({},this.newCredit));
        }
      }
      else{
        this.editedCredits.splice(0);
      }
      
    },
    deleteCredit(credit) {
      if (confirm(this.$storeUm6p.Label.SupprimerLigne)) {
        this.creditIndex = this.editedCredits.indexOf(credit);

        var cred = Object.assign({}, credit);
        cred.Supprimer = true;
        Object.assign(this.editedCredits[this.creditIndex], cred);

        this.creditIndex = -1;
      }
    },
    deleteBiens(bien) {
      if (confirm(this.$storeUm6p.Label.SupprimerLigne)) {
        this.bienIndex = this.editedBiensImmo.indexOf(bien);

        var item = Object.assign({}, bien);
        item.Supprimer = true;
        Object.assign(this.editedBiensImmo[this.bienIndex], item);

        this.bienIndex = -1;
      }
    },
    checkRevenuAlerts() {
      const situationPro = this.$storeBourse.editedItem.situationPro;
      const revenuMensuel = this.$storeBourse.editedItem.revenuNetMensuelDeclare;
      const pension = this.$storeBourse.editedItem.sommeRnmPensionsPercues;

      // Cas 1: SituationProActif + RevenuMensuelNetDeclare = 0
      if (situationPro == this.$storeCatalogue.SituationProActif && 
          (revenuMensuel == null || revenuMensuel == 0)) {
        this.dialogRevenuAlert.message = this.$storeUm6p.Label.AutresRevenus.RenseignementRevenuMensuel;
        this.dialogRevenuAlert.model = true;
        return;
      }

      // Cas 2: SituationProRetraiteActif + RevenuMensuelNetDeclare = 0 ET SommeRnmPensionsPercues = 0
      if (situationPro == this.$storeCatalogue.DataId.SituationProRetraiteActif && 
          (revenuMensuel == null || revenuMensuel == 0) &&
          (pension == null || pension == 0)) {
        this.dialogRevenuAlert.message = this.$storeUm6p.Label.AutresRevenus.RenseignementRevenuMensuelPension;
        this.dialogRevenuAlert.model = true;
        return;
      }

      // Cas 3: SituationProRetraite + SommeRnmPensionsPercues = 0
      if (situationPro == this.$storeCatalogue.SituationProRetraite && 
          (pension == null || pension == 0)) {
        this.dialogRevenuAlert.message = this.$storeUm6p.Label.AutresRevenus.RenseignementPensionRentraite;
        this.dialogRevenuAlert.model = true;
        return;
      }
    },
  },
  mounted() {
    this.$refs.refRevenus.resetValidation();
  },
};
</script>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
